/**
 * De keuzemogelijkheden van een 'kies er één'-vraag op het publieke
 * intakeformulier.
 *
 * De opties komen als prop binnen, niet uit Firestore: deze pagina heeft geen
 * login en haalt haar hele definitie via de Cloud Function op.
 * AI-CONTEXT: See docs/decisions.md#adr-022
 *
 * @param {object} props
 * @param {Array<{ID: string, Option: string}>} [props.options] - Antwoordopties, al op volgorde
 */
const IntakeFormMultipleOptions = ({ options }) => {
  return (
    <>
      {(options || []).map((option) => (
        <option key={option.ID} value={option.Option}>
          {option.Option}
        </option>
      ))}
    </>
  );
};

export default IntakeFormMultipleOptions;
